<template>
    <div>
        <div v-if="errors && errors.datum_od" class="alert alert-error rich-text">
            <p>{{ errors.datum_od[0] }}</p>
        </div>

        <form method="post" @submit.prevent="submit">
            <div class="flex items-center mt-10">
                <div class="flex-none flex justify-center items-center w-9 h-9 pl-1 text-18 font-bold bg-gray-100 rounded-full">3.</div>
                <h2 class="h2 mt-0 ml-3">{{ trans.get('rezervace.kontakty_nadpis') }}</h2>
            </div>

            <div class="md:flex mt-5 md:space-x-4">
                <div class="md:w-1/2">
                    <label class="text-15">{{ trans.get('rezervace.kontakty_jmeno') }}:
                        <input v-model="kontakty.jmeno" type="text" maxlength="15" name="jmeno" autocomplete="given-name" :class="'form-input form-control w-full' + (errors && errors.jmeno ? ' border-red-700' : '')">
                    </label>

                    <div v-if="errors && errors.jmeno" class="validation-error">{{ errors.jmeno[0] }}</div>
                </div>

                <div class="md:w-1/2 mt-4 md:mt-0">
                    <label class="text-15">{{ trans.get('rezervace.kontakty_prijmeni') }}:
                        <input v-model="kontakty.prijmeni" type="text" maxlength="30" name="prijmeni" autocomplete="family-name" :class="'form-input form-control w-full' + (errors && errors.prijmeni ? ' border-red-700' : '')">
                    </label>

                    <div v-if="errors && errors.prijmeni" class="validation-error">{{ errors.prijmeni[0] }}</div>
                </div>
            </div>

            <div class="md:flex md:space-x-4 mt-4">
                <div class="md:w-1/2">
                    <label class="text-15">{{ trans.get('rezervace.kontakty_telefon') }}:
                        <input v-model="kontakty.telefon" type="tel" maxlength="60" name="telefon" autocomplete="tel" :class="'form-input form-control w-full' + (errors && errors.telefon ? ' border-red-700' : '')">
                    </label>

                    <div v-if="errors && errors.telefon" class="validation-error">{{ errors.telefon[0] }}</div>
                </div>

                <div class="md:w-1/2 mt-4 md:mt-0">
                    <label class="text-15">E-mail:
                        <input v-model="kontakty.email" type="email" maxlength="80" name="email" autocomplete="email" :class="'form-input form-control w-full' + (errors && errors.email ? ' border-red-700' : '')">
                    </label>

                    <div v-if="errors && errors.email" class="validation-error">{{ errors.email[0] }}</div>
                </div>
            </div>

            <div class="md:flex md:space-x-4 mt-4">
                <div class="md:w-1/2">
                    <label class="text-15">{{ trans.get('rezervace.kontakty_ulice') }}:
                        <input v-model="kontakty.ulice" type="text" maxlength="30" name="ulice" autocomplete="address-line1" :class="'form-input form-control w-full' + (errors && errors.ulice ? ' border-red-700' : '')">
                    </label>

                    <div v-if="errors && errors.ulice" class="validation-error">{{ errors.ulice[0] }}</div>
                </div>

                <div class="md:w-1/2 mt-4 md:mt-0">
                    <div class="flex space-x-4">
                        <div class="w-1/3">
                            <label class="text-15">{{ trans.get('rezervace.kontakty_psc') }}:
                                <input v-model="kontakty.psc" type="text" maxlength="10" name="psc" autocomplete="postal-code" :class="'form-input form-control w-full' + (errors && errors.psc ? ' border-red-700' : '')">
                            </label>

                            <div v-if="errors && errors.psc" class="validation-error">{{ errors.psc[0] }}</div>
                        </div>

                        <div class="w-2/3 mt-0">
                            <label class="text-15">{{ trans.get('rezervace.kontakty_mesto') }}:
                                <input v-model="kontakty.mesto" type="text" maxlength="40" name="mesto" autocomplete="address-level2" :class="'form-input form-control w-full' + (errors && errors.mesto ? ' border-red-700' : '')">
                            </label>

                            <div v-if="errors && errors.mesto" class="validation-error">{{ errors.mesto[0] }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <label class="text-15">{{ trans.get('rezervace.kontakty_stat') }}:
                    <select v-model="kontakty.stat" name="stat" autocomplete="country" :class="'form-select form-control w-full' + (errors && errors.stat ? ' border-red-700' : '')">
                        <option value="">{{ trans.get('rezervace.kontakty_stat_vychozi') }}</option>

                        <optgroup :label="trans.get('rezervace.kontakty_stat_nejcastejsi')">
                            <option v-for="stat in statyCaste" :key="stat.id_staty" :value="stat.kod">{{ stat.nazev_klient }}</option>
                        </optgroup>

                        <optgroup :label="trans.get('rezervace.kontakty_stat_ostatni')">
                            <option v-for="stat in statyOstatni" :key="stat.id_staty" :value="stat.kod">{{ stat.nazev_klient }}</option>
                        </optgroup>
                    </select>
                </label>

                <div v-if="errors && errors.stat" class="validation-error">{{ errors.stat[0] }}</div>
            </div>

            <div class="mt-6">
                <label class="inline-flex items-center text-15 hover:cursor-pointer">
                    <input v-model="kontakty.na_firmu" type="checkbox" class="form-checkbox form-control">
                    <span class="ml-2">{{ trans.get('rezervace.kontakty_firma') }}</span>
                </label>
            </div>

            <div v-if="kontakty.na_firmu" class="md:flex md:space-x-4 mt-2">
                <div class="md:w-1/2">
                    <label class="text-15">{{ trans.get('rezervace.kontakty_nazev') }}:
                        <input v-model="kontakty.firma" type="text" maxlength="30" name="firma" :class="'form-input form-control w-full' + (errors && errors.firma ? ' border-red-700' : '')">
                    </label>

                    <div v-if="errors && errors.firma" class="validation-error">{{ errors.firma[0] }}</div>
                </div>

                <div class="md:w-1/2 mt-4 md:mt-0">
                    <div class="flex space-x-4">
                        <div class="w-1/2">
                            <label class="text-15">{{ trans.get('rezervace.kontakty_ico') }}:
                                <input v-model="kontakty.ico" type="text" maxlength="10" name="ico" :class="'form-input form-control w-full' + (errors && errors.ico ? ' border-red-700' : '')">
                            </label>

                            <div v-if="errors && errors.ico" class="validation-error">{{ errors.ico[0] }}</div>
                        </div>

                        <div class="w-1/2 mt-0">
                            <label class="text-15">{{ trans.get('rezervace.kontakty_dic') }}:
                                <input v-model="kontakty.dic" type="text" maxlength="14" name="dic" :class="'form-input form-control w-full' + (errors && errors.dic ? ' border-red-700' : '')">
                            </label>

                            <div v-if="errors && errors.dic" class="validation-error">{{ errors.dic[0] }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center mt-10">
                <div class="flex-none flex justify-center items-center w-9 h-9 pl-1 text-18 font-bold bg-gray-100 rounded-full">4.</div>
                <h2 class="h2 mt-0 ml-3">{{ trans.get('rezervace.ostatni_nadpis') }}</h2>
            </div>

            <div class="mt-4">
                <label class="text-15">{{ trans.get('rezervace.ostatni_poznamka') }}:
                    <input v-model="kontakty.poznamka" type="text" maxlength="2000" name="poznamka" :class="'form-input form-control w-full' + (errors && errors.poznamka ? ' border-red-700' : '')">
                </label>

                <div v-if="errors && errors.poznamka" class="validation-error">{{ errors.poznamka[0] }}</div>
            </div>

            <div class="mt-6">
                <label class="inline-flex items-center text-15 hover:cursor-pointer">
                    <input v-model="kontakty.podminky" type="checkbox" :class="'form-checkbox form-control' + (errors && errors.podminky ? ' border-red-700' : '')">
                    <span class="ml-2">
                        {{ trans.get('rezervace.kontakty_podminky') }}<span v-if="podminkyOdkaz">. <a :href="podminkyOdkaz" target="_blank" class="link mt-1">{{ trans.get('rezervace.podminky') }} &rarr;</a></span>
                    </span>
                </label>

                <div v-if="errors && errors.podminky" class="validation-error">{{ errors.podminky[0] }}</div>
            </div>

            <div class="mt-8 text-center">
                <div v-if="! sending">
                    <button type="submit" class="w-full py-4 text-18 font-semibold text-white bg-blue-500 hover:bg-blue-600 whitespace-nowrap rounded-3 duration-300">
                        {{ trans.get('rezervace.kontakty_tlacitko') }}
                    </button>
                </div>
                <div v-else>
                    <div class="flex items-center justify-center w-full py-4 text-18 font-semibold text-white text-center bg-blue-300 rounded-3 duration-300 cursor-not-allowed">
                        <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>

                        <div class="ml-2 md:ml-4">
                            {{ trans.get('rezervace.kontakty_tlacitko') }}
                        </div>
                    </div>
                </div>

                <img src="/img/gopay-loga.png" alt="Loga přijímaných platebních karet a loga systému 3D-Secure" class="mt-6 mx-auto">
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        initKontakty: Object,
        statyCaste: Array,
        statyOstatni: Array,
        podminkyOdkaz: String,
    },

    data: function () {
        return {
            kontakty: {
                stat: '',
                podminky: false,
            },
            errors: {},
            sending: false,
        }
    },

    methods: {
        submit() {
            this.errors = {};
            this.sending = true;

            axios.post('/kontakty', this.kontakty)
                .then(response => {
                    window.location = response.data.redirect_url;
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                        this.sending = false;
                    }
            });
        },
    },

    created() {
        if (this.initKontakty) {
            this.kontakty = this.initKontakty;
        }
    },
}
</script>
